import React from 'react';
import { CustomIcon } from './CustomIcon';
export const Solution = () => {
  const features = [{
    icon: 'book',
    text: 'Una guía que sí entiende tus precios.'
  }, {
    icon: 'dollar',
    text: 'Tus sueldos.'
  }, {
    icon: 'credit-card',
    text: 'Tus tarjetas.'
  }, {
    icon: 'lock',
    text: 'Tus miedos.'
  }, {
    icon: 'brain',
    text: 'Tu realidad.'
  }];
  return <section className="py-16 bg-gradient-to-b from-gray-50 to-white" data-id="element-283">
      <div className="container mx-auto px-4" data-id="element-284">
        <div className="text-center mb-12" data-id="element-285">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-286">
            Imagina esto por un segundo:
          </h2>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-287">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-288">
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-8 rounded-2xl shadow-xl" data-id="element-289">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-290">
                Todo lo que necesitas en un solo lugar
              </h3>
              <div className="space-y-4" data-id="element-291">
                {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 border-l-4 border-teal-500" data-id="element-292">
                    <div className="flex items-center gap-4" data-id="element-293">
                      <div className="bg-gradient-to-br from-teal-500 to-blue-500 p-3 rounded-lg shadow-md flex-shrink-0" data-id="element-294">
                        <CustomIcon name={feature.icon} className="text-white" size={24} data-id="element-295" />
                      </div>
                      <p className="text-gray-800 font-semibold text-lg flex-1" data-id="element-296">
                        {feature.text}
                      </p>
                    </div>
                  </div>)}
              </div>
              <div className="mt-6 text-center" data-id="element-297">
                <p className="text-teal-700 font-medium italic" data-id="element-298">
                  ✨ Diseñado específicamente para latinoamericanos
                </p>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 md:pl-12 flex justify-center" data-id="element-299">
            <div className="grid grid-cols-2 gap-6" data-id="element-300">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9yPD7Z1M2QVGteGbTk2hx/ChatGPT_Image_15_nov_2025%2C_01_53_13_p.m..png" alt="Plan de Ahorro de 52 Semanas" className="w-full rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-301" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dkUp3hzcXxrze6zjfYkEDZ/ChatGPT_Image_15_nov_2025%2C_01_45_54_p.m..png" alt="Plantilla de Presupuesto Mensual" className="w-full rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-302" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jGMDtUY4pFugaAvqRW3jYu/ChatGPT_Image_15_nov_2025%2C_01_56_29_p.m..png" alt="Mini-guía: Cómo Aumentar tus Ingresos" className="w-full rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-303" />
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hXWAUYps27XEVStygyPcdD/Generated_Image_November_15%2C_2025_-_1_34PM.png" alt="Tu Nuevo Inicio Financiero" className="w-full rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300" data-id="element-304" />
            </div>
          </div>
        </div>
        <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-305">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-306">
            La Solución Única:
          </h3>
          <div className="bg-teal-100 p-6 rounded-lg" data-id="element-307">
            <p className="text-lg text-gray-800" data-id="element-308">
              Un método nacido en Latinoamérica, probado en Latinoamérica, y
              hecho para latinos como tú.
            </p>
          </div>
        </div>
      </div>
    </section>;
};